import techZeefdruk from "@/assets/techniques/zeefdruk.webp";
import techTransfer from "@/assets/techniques/transferdruk.webp";
import techBorduren from "@/assets/techniques/borduren.webp";
import techDtf from "@/assets/techniques/dtf.webp";
import { ArrowRight } from "@/components/Icon";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const techniques = [
  {
    title: "Zeefdruk",
    desc: "Klassieke druktechniek met heldere, dekkende kleuren en een duurzaam resultaat. Ideaal voor T-shirts, hoodies en polo's.",
    img: techZeefdruk,
    min: "Vanaf 10 stuks",
    href: "/druktechnieken/zeefdrukkerij",
  },
  {
    title: "Transferdruk",
    desc: "Full color bedrukking met heldere kleuren en een haarscherp resultaat. Perfect voor foto's en gedetailleerde ontwerpen.",
    img: techDtf,
    min: "Vanaf 10 stuks",
    href: "/druktechnieken/transferdruk",
  },
  {
    title: "Borduren",
    desc: "Borduren geeft kleding een luxe en duurzame uitstraling. Ideaal voor bedrijfskleding, polo's en sweaters.",
    img: techBorduren,
    min: "Vanaf 25 stuks",
    href: "/druktechnieken/borduren",
  },
  {
    title: "DTF Printing",
    desc: "Met DTF printing kunnen wij gedetailleerde en kleurrijke ontwerpen direct op textiel drukken. Ideaal voor prints met veel kleuren.",
    img: techTransfer,
    min: "Vanaf 10 stuks",
    href: "/druktechnieken/dtf-printing",
  },
];

const Techniques = () => (
  <section id="technieken" className="py-20 md:py-28 bg-[#fcfcfc]">
    <div className="container">
      <div className="text-center max-w-2xl mx-auto mb-14">
        <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#0a2933]">
          Onze druktechnieken
        </h2>
        <p className="text-muted-foreground">
          Welke techniek het beste is hangt af van het type kleding, het ontwerp en de oplage.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {techniques.map((t) => (
          <Link
            to={t.href}
            key={t.title}
            className="group bg-card rounded-2xl overflow-hidden border border-border hover:border-primary/40 hover:shadow-xl transition-all duration-300 flex flex-col"
          >
            <div className="relative overflow-hidden aspect-[4/3]">
              <img
                src={t.img}
                alt={t.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
                width={800}
                height={600}
              />
              <span className="absolute top-4 left-4 bg-primary text-primary-foreground text-xs font-semibold px-3 py-1 rounded-full">
                {t.min}
              </span>
            </div>
            <div className="p-6 space-y-3">
              <h3 className="font-heading font-semibold text-xl text-[#0a2933]">{t.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{t.desc}</p>
              <span className="inline-flex items-center text-primary text-sm font-medium group-hover:text-primary/80">
                Meer informatie <ArrowRight className="ml-1 w-4 h-4" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default Techniques;
